import { FC, useEffect, useState } from "react"
import { checkRegex, downloadFile } from "../../helpers"
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs"

type flyers = {
  uuid: string,
  name: string,
  section: string,
  url: string,
  preview_image?: string,
}

const Flyers: FC = () => {
  const [flyers, setFlyers] = useState<flyers[]>([]);
  const getFlyers = async () => {
    const resp = await fetch('https://django.skatled.ru/api/v1/files?section=Листовки');
    const flyers = await resp.json();
    setFlyers(flyers)
  }

  useEffect(() => {
    getFlyers();
    window.scrollTo(0, 0);
  },[])

  return (
    <>
      <Breadcrumbs />
      <div className='container-fluid flyers'>
        {flyers.length !== 0 ? flyers.map((flyer, idx) => (
          <div className="flyers__certificate" key={idx}>
            <img
              src={checkRegex(flyer.url, flyer.preview_image) ? checkRegex(flyer.url, flyer.preview_image) : `${process.env.REACT_APP_DJANGO_DOMEN}/images/Others/bonuses.png`}
              alt=""
              onClick={() => downloadFile(flyer.url, flyer.name)}
            />
            <p>{flyer.name}</p>
          </div>
        )) : (<h1>Нет доступных листовок</h1>)}
      </div>
    </>
  )
}

export default Flyers;
